import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import { DISABLE_MODAL_RETRIES } from '../../RequestManagerConstants';
import { getApiToUsePinStatus, CONTROL_PIN_STATUS_API } from "../../../utils/pinParental/UtilsPin";

class PinStatusWithTimerValidationTask extends AbstractRequestTask {
    constructor(params = {}, version = 'v1') {
        super();
        this.ownParams = params;
        this.version = version; 
    }

    getParams() {
        const params = super.getParams();
        if(getApiToUsePinStatus() === CONTROL_PIN_STATUS_API){
            const {
                user_token = '',
                session_userhash = ''
            } = store.getState().user;
            delete params.api_version;
            delete params.HKS;
            return {...params, user_hash:session_userhash, user_token, ...this.ownParams };
        }
        if(params.user_token) {
            delete params.api_version;
            delete params.HKS;
        } else {
            delete params.user_token;
        }
        return {...params, ...this.ownParams};
    }

    getShowErrorModal(){
        return DISABLE_MODAL_RETRIES;
    }

    getUrl() {
        const params = super.getParams();
        const path = params.user_token ? getApiToUsePinStatus() : '/services/user/statuscontrolpin';
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}${path}`; 
    }

}

export default PinStatusWithTimerValidationTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/PinStatusWithTimerValidationTask.js